import { createSelector } from '@reduxjs/toolkit';

export const getReviewsState = (state) => state.reviews;

export const getReviews = createSelector(getReviewsState, (reviewsState) => reviewsState.data);
